import React from 'react';
import { motion } from 'framer-motion';
import { Users } from 'lucide-react';
import { RiyalIcon } from './icons';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAmountVisibility, maskAmount } from './AmountVisibilityContext';

type OrganizerStats = {
  totalPilgrims: number;
  regularPilgrims: number;
  notOwnerPilgrims: number;
  totalAmount: number;
  bonusAmount: number;
};

type Props = {
  organizerStats: Record<string, OrganizerStats>;
};

export const AdminStatsPanel = ({ organizerStats }: Props) => {
  const { translations } = useLanguage();
  const { showAmounts } = useAmountVisibility();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white p-6 rounded-xl shadow-sm"
    >
      <h2 className="text-lg font-semibold mb-4 text-primary-700">
        {translations?.adminStats?.title || 'All Organizers Statistics'}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
          <div className="text-sm text-gray-600 mb-1">
            {translations?.adminStats?.totalPilgrims || 'Total Pilgrims'}
          </div>
          <div className="text-xl font-bold text-primary-600">
            {Object.values(organizerStats).reduce((sum, stat) => sum + stat.totalPilgrims, 0)}
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
          <div className="text-sm text-gray-600 mb-1">
            {translations?.adminStats?.totalAmount || 'Total Amount'}
          </div>
          <div className="flex items-center text-xl font-bold text-green-600">
            {maskAmount(Object.values(organizerStats).reduce((sum, stat) => sum + stat.totalAmount, 0), showAmounts)} 
            <RiyalIcon size={18} className="mr-1 text-green-500" />
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
          <div className="text-sm text-gray-600 mb-1">
            {translations?.adminStats?.totalBonuses || 'Total Bonuses'}
          </div>
          <div className="flex items-center text-xl font-bold text-blue-600">
            {maskAmount(Object.values(organizerStats).reduce((sum, stat) => sum + stat.bonusAmount, 0), showAmounts)} 
            <RiyalIcon size={18} className="mr-1 text-blue-500" />
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
          <div className="text-sm text-gray-600 mb-1">
            {translations?.adminStats?.pendingPilgrims || 'Pending Pilgrims'}
          </div>
          <div className="text-xl font-bold text-yellow-600">
            {Object.values(organizerStats).reduce((sum, stat) => sum + stat.notOwnerPilgrims, 0).toLocaleString()}
          </div>
        </div>
      </div>
    </motion.div>
  );
};